<template>
    <div class="card mb-0">
        <div class="card-header">
            <table style="width: 100%;">
                <tbody>
                <tr>
                    <td>{{ title }}</td>
                    <td style="font-weight: normal;text-align: right;">
                        <template v-if="!readonly">
                            <ButtonAction :action="actions.updateProject" :forward-events="true"
                                          v-on:forward-event="$emit($event.event, $event.data)"
                                          v-if="actions && actions.updateProject"/>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="card-body">
            <table class="table table-borderless table-sm mb-0">
                <tbody>
                <tr>
                    <td class="p-0" style="width: 120px;"><b>{{ $i18n.t('translations.Number') }}</b></td>
                    <td class="p-0">{{ data.id }}</td>
                </tr>
                <tr>
                    <td class="p-0" style="width: 120px;"><b>{{ $i18n.t('translations.Name') }}</b></td>
                    <td class="p-0">
                        <LinkAction :action="actions.linkProject" v-if="actions && actions.linkProject"/>
                        <template v-else>{{ data.name_translation }}</template>
                    </td>
                </tr>
                <tr v-if="data.reference">
                    <td class="p-0" style="width: 120px;"><b>{{ $i18n.t('translations.Reference') }}</b></td>
                    <td class="p-0">{{ data.reference }}</td>
                </tr>
                <tr v-if="data.manager">
                    <td class="p-0" style="width: 120px;"><b>{{ $i18n.t('translations.Manager') }}</b></td>
                    <td class="p-0">{{ data.manager }}</td>
                </tr>
                <tr v-if="data.correspondent">
                    <td class="p-0" style="width: 120px;"><b>{{ $i18n.t('translations.Correspondent') }}</b></td>
                    <td class="p-0">{{ data.correspondent }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer light" v-if="actions && (sketchUpBrowser && actions.toggleSketchUpProject)">
            <table style="width: 100%;">
                <tbody>
                <tr>
                    <td>
                        <ToggleAction :action="actions.toggleSketchUpProject"
                                      :toggled="linkedToSketchUp" :forward-events="true"
                                      v-on:forward-event="$emit($event.event, $event.data)"
                                      v-if="sketchUpBrowser && actions.toggleSketchUpProject"/>
                    </td>
                    <td style="font-weight: normal;text-align: right;">
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import ButtonAction from "@/components/actions/ButtonAction.vue";
import LinkAction from "@/components/actions/LinkAction.vue";
import ToggleAction from "@/components/actions/ToggleAction.vue";

/* global sketchup:false */

export default {
    name: "ProjectCard",
    components: {
        ButtonAction,
        LinkAction,
        ToggleAction,
    },
    props: ['title', 'data', 'linkedToSketchUp', 'actions', 'readonly'],
    data() {
        return {
            sketchUpBrowser: (typeof sketchup !== "undefined"),
        }
    },
}
</script>

<style scoped>
</style>
